const videoPlayer = document.querySelectorAll('.video-player');

window.addEventListener('load', () => {
  const pauseOtherVideo = () => {
    const otherVideo = document.querySelectorAll('.video-player video');
    otherVideo.forEach((item) => {
      const parentElem = item.closest('.video-player');
      item.pause();
      parentElem.classList.remove('is-playing');
      cancelAnimationFrame(null);
    });
  };

  videoPlayer.forEach((element) => {
    const videoPlayerContainer = element;
    const playIconContainer = element.querySelectorAll('.video-player__play');
    const videoElem = element.querySelector('video');
    const seekSlider = element.querySelector('.video-player__seek-slider');
    const durationContainer = element.querySelector('.video-player__time-total');
    const currentTimeContainer = element.querySelector('.video-player__time-current');
    const fullScreenButton = element.querySelector('.video-player__full-screen');
    const closeButton = element.querySelector('.video__close');
    const videoInitElem = element.querySelector('.video-player__video-init');
    let raf = null;

    const calculateTime = (secs) => {
      const minutes = Math.floor(secs / 60);
      const seconds = Math.floor(secs % 60);
      const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
      return `${minutes}:${returnedSeconds}`;
    };

    const whilePlaying = () => {
      seekSlider.value = Math.floor(videoElem.currentTime);
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      videoPlayerContainer.style.setProperty('--seek-before-width', `${(seekSlider.value / seekSlider.max) * 100}%`);
      raf = requestAnimationFrame(whilePlaying);
    };

    const playVideo = () => {
      videoElem.play();
      videoPlayerContainer.classList.add('is-playing');
      requestAnimationFrame(whilePlaying);
    };

    const pauseVideo = () => {
      videoElem.pause();
      videoPlayerContainer.classList.remove('is-playing');
      cancelAnimationFrame(raf);
    };

    playIconContainer.forEach((ele) => {
      ele.addEventListener('click', () => {
        const isPlaying = videoPlayerContainer.classList.contains('is-playing');
        if (!isPlaying) {
          pauseOtherVideo();
          playVideo();
        } else {
          pauseVideo();
          pauseOtherVideo();
        }
      });
    });

    attachEvent('[data-tab]', 'click', () => pauseVideo());

    const showRangeProgress = (rangeInput) => {
      if (rangeInput === seekSlider) {
        videoPlayerContainer.style.setProperty('--seek-before-width', `${(rangeInput.value / rangeInput.max) * 100}%`);
      }
    };

    seekSlider.addEventListener('input', (e) => showRangeProgress(e.target));

    const displayDuration = () => {
      durationContainer.textContent = calculateTime(videoElem.duration);
    };

    const setSliderMax = () => {
      seekSlider.max = Math.floor(videoElem.duration);
    };

    const displayBufferedAmount = () => {
      if (videoElem.buffered.length) {
        const bufferedAmount = Math.floor(videoElem.buffered.end(videoElem.buffered.length - 1));
        videoPlayerContainer.style.setProperty('--buffered-width', `${(bufferedAmount / seekSlider.max) * 100}%`);
      }
    };

    const videoEnd = () => {
      videoElem.addEventListener('ended', () => {
        videoPlayerContainer.classList.remove('is-playing');

        if (videoInitElem) {
          videoInitElem.classList.remove('fullscreen');
          document.body.classList.remove('fullscreen-video');
        }
      });
    };

    const videoFunctions = () => {
      displayBufferedAmount();
      displayDuration();
      setSliderMax();
      videoEnd();
    };

    if (videoElem.readyState > 0) videoFunctions();
    else videoElem.addEventListener('loadedmetadata', videoFunctions);

    videoElem.addEventListener('progress', displayBufferedAmount);

    seekSlider.addEventListener('input', () => {
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      if (!videoElem.paused) cancelAnimationFrame(raf);
    });

    seekSlider.addEventListener('change', () => {
      videoElem.currentTime = seekSlider.value;
      if (!videoElem.paused) requestAnimationFrame(whilePlaying);
    });

    fullScreenButton.addEventListener('click', () => {
      pauseOtherVideo();
      if (videoInitElem) {
        videoInitElem.classList.toggle('fullscreen');
        document.body.classList.toggle('fullscreen-video', videoInitElem.classList.contains('fullscreen'));
      }
      if (videoElem.paused) playVideo();
    });

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        if (videoInitElem) {
          videoInitElem.classList.remove('fullscreen');
          document.body.classList.remove('fullscreen-video');
        }
      });
    }
  });
});
